import type { HttpErrorResponse } from '@angular/common/http';

import type { EmailProvider } from '@core/email-templates-types';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<EmailProvider | null>()(
  EntityStoreKey.emailProviders,
  {
    customActions: adapter => ({
      updateAutoForward: (state, payload: boolean) => adapter.markAsPending(state),
      updateAutoForwardSuccess: (state, payload: EmailProvider) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      updateAutoForwardFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),
    }),
  },
);

export {
  actions as EmailProvidersActions,
  selectors as EmailProvidersSelectors,
  reducer as EmailProvidersReducer,
  namespace as EmailProvidersNamespace,
};
